import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c60d1cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "alert alert-danger mb-0" }
const _hoisted_4 = { class: "card mb-5 mb-xl-10" }
const _hoisted_5 = { class: "card-header border-0" }
const _hoisted_6 = { class: "card-title m-0" }
const _hoisted_7 = { class: "fw-bolder m-0" }
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_10 = { class: "form-check-label fw-bold text-gray-700" }
const _hoisted_11 = { class: "card-body border-top p-9" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_14 = { class: "col-lg-3 col-form-label required fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-9 fv-row" }
const _hoisted_16 = { class: "form-text" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-3 col-form-label required fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-9 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-lg-9 fv-row" }
const _hoisted_25 = ["inputmode", "value", "onInput", "onBlur"]
const _hoisted_26 = {
  key: 0,
  class: "form-text"
}
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted mb-6"
}
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-3 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-9 fv-row d-flex align-items-center" }
const _hoisted_33 = { class: "form-check-label fw-bold" }
const _hoisted_34 = { class: "offset-lg-3 col-lg-9 fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-9" }
const _hoisted_39 = { class: "input-group" }
const _hoisted_40 = ["value"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "card mb-5 mb-xl-10" }
const _hoisted_43 = { class: "card-header border-0" }
const _hoisted_44 = { class: "card-title m-0" }
const _hoisted_45 = { class: "fw-bolder m-0" }
const _hoisted_46 = { class: "card-body border-top p-9" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-xl-7" }
const _hoisted_49 = { class: "form-label required fw-bold fs-6" }
const _hoisted_50 = { class: "d-flex justify-content-between" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "fv-row" }
const _hoisted_54 = { class: "form-label fw-bold fs-6" }
const _hoisted_55 = { class: "form-text" }
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "col-xl-5 mt-10 mt-xl-0" }
const _hoisted_59 = { class: "form-label fw-bold fs-6" }
const _hoisted_60 = { class: "deeplink-phone" }
const _hoisted_61 = { class: "text-white-50 fs-8 mb-1 px-1" }
const _hoisted_62 = ["dir"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "deeplink-notification__icon",
  src: "/media/logos/favicon.ico",
  alt: ""
}, null, -1))
const _hoisted_64 = { class: "deeplink-notification__content" }
const _hoisted_65 = { class: "d-flex justify-content-between" }
const _hoisted_66 = { class: "fw-bolder text-gray-900 text-truncate" }
const _hoisted_67 = { class: "text-muted fs-8 ms-2 me-2 flex-shrink-0" }
const _hoisted_68 = { class: "text-gray-700 fs-7 deeplink-notification__body" }
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "card mb-5 mb-xl-10" }
const _hoisted_71 = { class: "card-header border-0" }
const _hoisted_72 = { class: "card-title m-0" }
const _hoisted_73 = { class: "fw-bolder m-0" }
const _hoisted_74 = { class: "card-body border-top p-9" }
const _hoisted_75 = { class: "d-flex mb-8" }
const _hoisted_76 = { class: "form-check-label fw-bold" }
const _hoisted_77 = { class: "position-relative mb-4" }
const _hoisted_78 = ["placeholder", "disabled"]
const _hoisted_79 = {
  key: 0,
  class: "list-group mt-2 deeplink-member-results"
}
const _hoisted_80 = {
  key: 0,
  class: "list-group-item text-muted"
}
const _hoisted_81 = {
  key: 1,
  class: "list-group-item text-muted"
}
const _hoisted_82 = { class: "fw-bold" }
const _hoisted_83 = {
  class: "text-muted fs-7",
  dir: "ltr"
}
const _hoisted_84 = ["disabled", "onClick"]
const _hoisted_85 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_86 = { class: "text-gray-700 fw-bold" }
const _hoisted_87 = { class: "d-flex flex-wrap gap-2 mb-2" }
const _hoisted_88 = ["aria-label", "onClick"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-5 text-primary" }, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "fv-plugins-message-container mb-3" }
const _hoisted_92 = { class: "fv-help-block" }
const _hoisted_93 = {
  key: 0,
  class: "text-warning fs-7 mb-3"
}
const _hoisted_94 = { class: "text-muted fs-7" }
const _hoisted_95 = {
  key: 1,
  class: "alert alert-warning mb-0"
}
const _hoisted_96 = { class: "card" }
const _hoisted_97 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = ["disabled", "data-kt-indicator"]
const _hoisted_100 = { class: "indicator-label" }
const _hoisted_101 = { class: "indicator-progress" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (!_ctx.canSend || _ctx.forbidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('deeplinkNoPermission')), 1)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_Form, {
        key: 1,
        ref: "formRef",
        class: "form",
        "validation-schema": _ctx.notificationSchema,
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.translate('deeplinkSectionDestination')), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.advanced) = $event)),
                    class: "form-check-input",
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.advanced]
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('deeplinkAdvanced')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.destinationsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.destinationsError) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-danger ms-3",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadDestinations && _ctx.loadDestinations(...args)))
                    }, _toDisplayString(_ctx.translate('deeplinkRetry')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.advanced)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('deeplinkPasteLink')), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.rawDeeplink,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rawDeeplink) = $event)),
                        name: "rawDeeplink",
                        type: "text",
                        dir: "ltr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: `${_ctx.DEEPLINK_BASE}?url=ads-list&lang=ar`
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.translate('deeplinkAdvancedHint')), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_ErrorMessage, { name: "rawDeeplink" })
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('deeplinkType')), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_Field, {
                          modelValue: _ctx.form.destination,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.destination) = $event)),
                          name: "destination"
                        }, {
                          default: _withCtx(({ value, handleChange }) => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              filterable: "",
                              "model-value": value,
                              loading: _ctx.destinationsLoading,
                              placeholder: _ctx.translate('deeplinkSelectType'),
                              "onUpdate:modelValue": handleChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.destinations, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.destination,
                                    label: _ctx.screenLabel(item),
                                    value: item.destination
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["model-value", "loading", "placeholder", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_ErrorMessage, { name: "destination" })
                          ])
                        ])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentParams, (param) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${_ctx.form.destination}-${param.key}`,
                        class: "row mb-6"
                      }, [
                        _createElementVNode("label", {
                          class: _normalizeClass(["col-lg-3 col-form-label fw-bold fs-6", { required: param.required }])
                        }, _toDisplayString(_ctx.paramLabel(param.key)), 3),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_Field, {
                            modelValue: _ctx.params[param.key],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.params[param.key]) = $event),
                            name: _ctx.fieldName(param.key)
                          }, {
                            default: _withCtx(({ value, handleChange, handleBlur }) => [
                              (param.spec.input === 'select')
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 0,
                                    class: "w-100",
                                    filterable: "",
                                    clearable: "",
                                    "model-value": value,
                                    loading: _ctx.isLookupLoading(param.spec),
                                    disabled: _ctx.isWaitingOnParent(param.spec),
                                    placeholder: 
                    _ctx.selectPlaceholder(param.spec, 'deeplinkSelectPlaceholder')
                  ,
                                    "onUpdate:modelValue": handleChange
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramOptions(param.spec), (option) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: option.value,
                                          label: option.label,
                                          value: option.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["model-value", "loading", "disabled", "placeholder", "onUpdate:modelValue"]))
                                : (param.spec.input === 'multiselect')
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      class: "w-100",
                                      multiple: "",
                                      filterable: "",
                                      clearable: "",
                                      "model-value": value || [],
                                      loading: _ctx.isLookupLoading(param.spec),
                                      disabled: _ctx.isWaitingOnParent(param.spec),
                                      placeholder: 
                    _ctx.selectPlaceholder(param.spec, 'deeplinkSelectMany')
                  ,
                                      "onUpdate:modelValue": handleChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramOptions(param.spec), (option) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: option.value,
                                            label: option.label,
                                            value: option.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["model-value", "loading", "disabled", "placeholder", "onUpdate:modelValue"]))
                                  : (param.spec.input === 'auction')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 2,
                                        class: "w-100",
                                        filterable: "",
                                        "allow-create": "",
                                        "default-first-option": "",
                                        clearable: "",
                                        "model-value": value,
                                        loading: _ctx.isLookupLoading(param.spec),
                                        placeholder: _ctx.translate('deeplinkAuctionPlaceholder'),
                                        "onUpdate:modelValue": handleChange
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramOptions(param.spec), (option) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: option.value,
                                              label: option.label,
                                              value: option.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["model-value", "loading", "placeholder", "onUpdate:modelValue"]))
                                    : (
                    param.spec.input === 'date' || param.spec.input === 'month'
                  )
                                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                          key: 3,
                                          class: "w-100",
                                          type: param.spec.input,
                                          "model-value": value,
                                          format: 
                    param.spec.input === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM'
                  ,
                                          "value-format": 
                    param.spec.input === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM'
                  ,
                                          placeholder: 
                    _ctx.translate(
                      param.spec.input === 'date'
                        ? 'deeplinkDatePlaceholder'
                        : 'deeplinkMonthPlaceholder'
                    )
                  ,
                                          "onUpdate:modelValue": handleChange
                                        }, null, 8, ["type", "model-value", "format", "value-format", "placeholder", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createElementBlock("input", {
                                          key: 4,
                                          type: "text",
                                          dir: "ltr",
                                          autocomplete: "off",
                                          class: "form-control form-control-lg form-control-solid",
                                          inputmode: 
                    param.spec.input === 'number' ? 'numeric' : 'text'
                  ,
                                          value: value,
                                          onInput: handleChange,
                                          onBlur: handleBlur
                                        }, null, 40, _hoisted_25))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "name"]),
                          (_ctx.form.destination === 'cce' && param.key === 'id')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.translate('deeplinkCceHint')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_ErrorMessage, {
                                name: _ctx.fieldName(param.key)
                              }, null, 8, ["name"])
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_ctx.selectedDestination && !_ctx.currentParams.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.translate('deeplinkNoParams')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('deeplinkLang')), 1),
                      _createElementVNode("div", _hoisted_32, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['ar', 'en'], (lang) => {
                          return _createElementVNode("label", {
                            key: lang,
                            class: "form-check form-check-custom form-check-solid me-10"
                          }, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.form.lang,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.lang) = $event),
                              class: "form-check-input",
                              type: "radio",
                              name: "lang",
                              value: lang
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "value"]),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.translate(
                      lang === 'ar' ? 'deeplinkLangAr' : 'deeplinkLangEn'
                    )), 1)
                          ])
                        }), 64))
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ErrorMessage, { name: "lang" })
                        ])
                      ])
                    ])
                  ], 64)),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('deeplinkLink')), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("input", {
                      type: "text",
                      readonly: "",
                      dir: "ltr",
                      class: "form-control form-control-lg form-control-solid",
                      value: _ctx.deeplink
                    }, null, 8, _hoisted_40),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light-primary",
                      disabled: !_ctx.deeplink,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyDeeplink && _ctx.copyDeeplink(...args)))
                    }, _toDisplayString(_ctx.translate(_ctx.copied ? 'deeplinkCopied' : 'deeplinkCopy')), 9, _hoisted_41)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.translate('deeplinkSectionMessage')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageFields, (text) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: text.name,
                      class: "mb-6 fv-row"
                    }, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate(text.label)), 1),
                      _createVNode(_component_Field, {
                        modelValue: _ctx.form[text.name],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[text.name]) = $event),
                        name: text.name,
                        as: text.multiline ? 'textarea' : 'input',
                        rows: text.multiline ? 3 : undefined,
                        maxlength: text.max,
                        dir: text.rtl ? 'rtl' : 'ltr',
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "as", "rows", "maxlength", "dir"]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_ErrorMessage, {
                              name: text.name
                            }, null, 8, ["name"])
                          ])
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["fs-7 mt-1", 
                    _ctx.form[text.name].length >= text.max
                      ? 'text-danger'
                      : 'text-muted'
                  ])
                        }, _toDisplayString(_ctx.form[text.name].length) + " / " + _toDisplayString(text.max), 3)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('deeplinkImageUrl')), 1),
                    _createVNode(_component_Field, {
                      modelValue: _ctx.form.imageUrl,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.imageUrl) = $event)),
                      name: "imageUrl",
                      type: "text",
                      dir: "ltr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "https://"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.translate('deeplinkImageHint')), 1),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_ErrorMessage, { name: "imageUrl" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate('deeplinkPreview')), 1),
                  _createElementVNode("div", _hoisted_60, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previews, (preview) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: preview.lang,
                        class: "mb-4"
                      }, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.translate(preview.label)), 1),
                        _createElementVNode("div", {
                          class: "deeplink-notification",
                          dir: preview.dir
                        }, [
                          _hoisted_63,
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("span", _hoisted_66, _toDisplayString(preview.title || _ctx.translate('deeplinkPreviewTitle')), 1),
                              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.translate('deeplinkNow')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_68, _toDisplayString(preview.body || _ctx.translate('deeplinkPreviewBody')), 1)
                          ]),
                          _createElementVNode("img", {
                            class: "deeplink-notification__image",
                            src: _ctx.previewImage,
                            alt: ""
                          }, null, 8, _hoisted_69)
                        ], 8, _hoisted_62)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.translate('deeplinkSectionAudience')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['members', 'all'], (audience) => {
                  return _createElementVNode("label", {
                    key: audience,
                    class: "form-check form-check-custom form-check-solid me-10"
                  }, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.form.audience,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.audience) = $event),
                      class: "form-check-input",
                      type: "radio",
                      name: "audience",
                      value: audience
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "value"]),
                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.translate(
                  audience === 'members'
                    ? 'deeplinkAudienceMembers'
                    : 'deeplinkAudienceAll'
                )), 1)
                  ])
                }), 64))
              ]),
              (_ctx.form.audience === 'members')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_77, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.memberQuery) = $event)),
                        type: "text",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('deeplinkSearchUsers'),
                        disabled: _ctx.selectedMembers.length >= _ctx.MAX_MEMBERS
                      }, null, 8, _hoisted_78), [
                        [_vModelText, _ctx.memberQuery]
                      ]),
                      (_ctx.memberQuery.trim().length >= 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            (_ctx.membersLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.translate('deeplinkSearching')), 1))
                              : (!_ctx.memberResults.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.translate('deeplinkNoUsersFound')), 1))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersLoading ? [] : _ctx.memberResults, (member) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: member.id,
                                class: "list-group-item d-flex align-items-center justify-content-between"
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_82, _toDisplayString(member.name || '—'), 1),
                                  _createElementVNode("div", _hoisted_83, _toDisplayString(member.phone || '—') + " · #" + _toDisplayString(member.id), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-light-primary",
                                  disabled: 
                    _ctx.isSelected(member) || _ctx.selectedMembers.length >= _ctx.MAX_MEMBERS
                  ,
                                  onClick: ($event: any) => (_ctx.addMember(member))
                                }, _toDisplayString(_ctx.translate(
                      _ctx.isSelected(member) ? 'deeplinkAdded' : 'deeplinkAdd'
                    )), 9, _hoisted_84)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.t('deeplinkSelectedCount', { count: _ctx.selectedMembers.length })), 1),
                      (_ctx.selectedMembers.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-light",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedMembers = []))
                          }, _toDisplayString(_ctx.translate('deeplinkClearAll')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMembers, (member) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: member.id,
                          class: "badge badge-light-primary fs-7 py-2 px-3"
                        }, [
                          _createTextVNode(_toDisplayString(member.name || member.phone) + " · #" + _toDisplayString(member.id) + " ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-icon btn-sm h-auto w-auto ms-2",
                            "aria-label": _ctx.translate('deeplinkRemove'),
                            onClick: ($event: any) => (_ctx.removeMember(member))
                          }, _hoisted_90, 8, _hoisted_88)
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_Field, {
                      as: "span",
                      class: "d-none",
                      name: "memberIds",
                      "model-value": _ctx.memberIds
                    }, null, 8, ["model-value"]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createVNode(_component_ErrorMessage, { name: "memberIds" })
                      ])
                    ]),
                    (_ctx.selectedMembers.length >= _ctx.MAX_MEMBERS)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.translate('deeplinkMaxUsers')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.translate('deeplinkMembersNote')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.translate('deeplinkAllWarning')), 1))
            ])
          ]),
          (_ctx.result)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "resultRef",
                class: _normalizeClass(["alert mb-5", `alert-${_ctx.result.variant}`])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.lines, (line, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(line), 1))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-white btn-active-light-primary me-2",
                disabled: _ctx.sending,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetAll && _ctx.resetAll(...args)))
              }, _toDisplayString(_ctx.translate('deeplinkReset')), 9, _hoisted_98),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.sending,
                "data-kt-indicator": _ctx.sending ? 'on' : null
              }, [
                _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.translate('deeplinkSend')), 1),
                _createElementVNode("span", _hoisted_101, [
                  _createTextVNode(_toDisplayString(_ctx.translate('deeplinkSending')) + " ", 1),
                  _hoisted_102
                ])
              ], 8, _hoisted_99)
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"]))
}